import { render, staticRenderFns } from "./shopify-warm-welcome.vue?vue&type=template&id=a8a92656&scoped=true&"
import script from "./shopify-warm-welcome.vue?vue&type=script&lang=js&"
export * from "./shopify-warm-welcome.vue?vue&type=script&lang=js&"
import style0 from "./shopify-warm-welcome.vue?vue&type=style&index=0&id=a8a92656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a92656",
  null
  
)

export default component.exports